import { useNavigate, useParams } from 'react-router-dom'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import AddMembersGroup from 'modules/posts/components/Groups/AddMembers'

const AddMembersGroupPage = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const { loading } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  return (
    <AddMembersGroup
      onClose={() => navigate(navigation.dashboard.fullPath())}
      groupId={Number(id)}
      contractVersions={contractVersions}
      loading={loading}
    />
  )
}

export default AddMembersGroupPage
